import { z } from 'zod';
export const tipoDocumento = z.enum([
    'NF-e',
    'NFC-e',
    'NFS-e Nacional',
    'NFS-e ABRASF',
    'CT-e',
    'CT-e OS',
]);
const dinheiro = z.number().finite().default(0);
export const participante = z.object({
    doc: z.string().default(''),
    nome: z.string().default(''),
    uf: z.string().default(''),
    mun: z.string().default(''),
    ie: z.string().default(''),
    im: z.string().default(''),
});
/** Tributos destacados no documento. Nada aqui é recalculado pelo sistema. */
export const tributos = z.object({
    bcIcms: dinheiro,
    icms: dinheiro,
    icmsSt: dinheiro,
    icmsDeson: dinheiro,
    fcp: dinheiro,
    ipi: dinheiro,
    pis: dinheiro,
    cofins: dinheiro,
    bcIss: dinheiro,
    iss: dinheiro,
    aliqIss: dinheiro,
    /** Base do regime IBS/CBS (NT 2025.002 e leiaute NFS-e nacional). */
    bcRtc: dinheiro,
    ibsUF: dinheiro,
    ibsMun: dinheiro,
    ibs: dinheiro,
    cbs: dinheiro,
});
export const retencoes = z.object({
    iss: dinheiro,
    /** Contribuição previdenciária retida: vRetPrev, vRetCP ou ValorInss. */
    inss: dinheiro,
    irrf: dinheiro,
    csll: dinheiro,
    pis: dinheiro,
    cofins: dinheiro,
    outras: dinheiro,
});
export const itemDocumento = z.object({
    numero: z.string().default(''),
    codigo: z.string().default(''),
    descricao: z.string().default(''),
    ncm: z.string().default(''),
    cfop: z.string().default(''),
    unidade: z.string().default(''),
    quantidade: dinheiro,
    valor: dinheiro,
    cstIcms: z.string().default(''),
    bcIcms: dinheiro,
    aliqIcms: dinheiro,
    icms: dinheiro,
    icmsSt: dinheiro,
    ipi: dinheiro,
    cstPis: z.string().default(''),
    pis: dinheiro,
    cstCofins: z.string().default(''),
    cofins: dinheiro,
    codigoServico: z.string().default(''),
    bcIss: dinheiro,
    aliqIss: dinheiro,
    iss: dinheiro,
    cstRtc: z.string().default(''),
    classTrib: z.string().default(''),
    bcRtc: dinheiro,
    ibsUF: dinheiro,
    ibsMun: dinheiro,
    cbs: dinheiro,
});
export const severidade = z.enum(['crit', 'warn', 'info']);
export const alerta = z.object({
    severidade,
    codigo: z.string(),
    mensagem: z.string(),
});
export const documentoFiscal = z.object({
    arquivo: z.string().default(''),
    tipo: tipoDocumento,
    modelo: z.string().default(''),
    numero: z.string().default(''),
    serie: z.string().default(''),
    /** Chave de acesso (NF-e/CT-e/NFS-e nacional) ou código de verificação (ABRASF). */
    chave: z.string().default(''),
    dataEmissao: z.string().default(''),
    competencia: z.string().default(''),
    sentido: z.string().default(''),
    emitente: participante,
    destinatario: participante,
    natureza: z.string().default(''),
    codigoServico: z.string().default(''),
    /** Item da LC 116 normalizado, ex.: "7.02". */
    itemServico: z.string().default(''),
    descricaoServico: z.string().default(''),
    municipio: z.string().default(''),
    art: z.string().default(''),
    valorProdutos: dinheiro,
    valorServicos: dinheiro,
    valorDesconto: dinheiro,
    valorTotal: dinheiro,
    tributos,
    retencoes,
    issRetido: z.boolean().default(false),
    issEstimado: z.boolean().default(false),
    temGrupoRtc: z.boolean().default(false),
    /** CNOs encontrados: campo estruturado ou texto complementar. 12 dígitos. */
    cnos: z.array(z.string()).default([]),
    itens: z.array(itemDocumento).default([]),
    observacoes: z.string().default(''),
    totalTributos: dinheiro,
    totalRetencoes: dinheiro,
});
//# sourceMappingURL=documento.js.map